<template>
	<el-input placeholder="请输入电话号码" v-model="num">
		<el-button slot="append" :disabled="disabled" @click="sendcode()">{{buttonName}}</el-button>
	</el-input>
</template>

<script>
	export default {
		data() {
			return {
				buttonName: "发送验证码",
				time: 60,
				disabled: false
			}
		},
		methods:{
			sendcode() {
				const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
				if (this.num == '') {
					return
				}
				if (!reg.test(this.num)) {
					return
				} else {
					let value={
						mobile: this.num
					};
					this.send(value)
					.then((res)=>{
						if(res.data.code==1)
						{
							this.time = 60;
							this.disabled = true;
							this.timer();
						}
					});
				}
			},
			timer() {
				if (this.time > 0) {
					this.time--;
					this.buttonName = this.time + "s后重新获取";
					setTimeout(this.timer, 1000);
				} else {
					this.time = 0;
					this.buttonName = "获取验证码";
					this.disabled = false;
				}
			}
		},
		props: {
			value: {
				type: String,
				default: ''
			}
		},
		mounted: function () {
			
		},
		computed:{
			num: {
				get () {
					return this.value;
				},
				set (value) {
					var o=document.createElement('input');
					o.input=()=>{
						this.$emit('input', value);
					}
					o.input();
				}
			}
		}
	}
</script>

<style>
</style>
